import Swiper from "swiper";
import { Pagination, EffectFlip, EffectFade, Autoplay } from "swiper/modules";

class HeroSlider {
    constructor($el) {
        this.$el = $el;
        this.$sliderEl = this.$el.find('[data-heroslider="slider"]');
        this.init();
    }

    init = () => {
        this.swiper = new Swiper(this.$sliderEl[0], {
            modules: [ Pagination, Autoplay, EffectFade],
            loop: true,
            effect: 'fade',
            speed: 1000,
            allowTouchMove: false,
            autoplay: {
                delay:3000,
                disableOnInteraction: false,
            },

        });
    }
}

export default HeroSlider;
